// 📄 pages/Proyectos/erpConfig.ts
// Opciones de "Tipo de ERP" para la sección Integración ERP del proyecto
// (ver ProyectoForm.tsx) — el sistema SAP con el que se integra Ariba.
// Fuente única para que el selector del formulario y cualquier lugar que
// muestre la etiqueta (p. ej. DetalleProyecto.tsx) no queden desincronizados.
export interface TipoErpOption {
  value: string;
  label: string;
}

export const TIPOS_ERP: TipoErpOption[] = [
  { value: 'ECC', label: 'ECC' },
  { value: 'S4HANA_ON_PREM', label: 'S/4HANA On-Premise' },
  { value: 'S4HANA_PRIVATE_CLOUD', label: 'S/4HANA Private Cloud Edition' },
  { value: 'S4HANA_PUBLIC_CLOUD', label: 'S/4HANA Public Cloud Edition' }
];

export const labelTipoErp = (value?: string): string =>
  TIPOS_ERP.find((t) => t.value === value)?.label || '';
